<template>
  <div class="container">
    <div class="tabBar">
      <div
        class="tabItem"
        v-for="tabBarItem in tabBarConfig"
        :class="{ active: currentActiveTabId === tabBarItem.key }"
        :key="tabBarItem.key"
        @click="handleTabBarClick(tabBarItem.key)"
      >
        {{ tabBarItem.title }}
      </div>
    </div>
    <TabContainer
      :value="currentActiveTabId"
      class="tabContainer"
      v-if="dataReady"
    >
      <TabContainerItem
        :id="tabBarItem.key"
        :key="tabBarItem.key"
        v-for="tabBarItem in tabBarConfig"
      >
        <component
          :is="tabBarItem.contentComp"
          @reportEvent="handleReportEvent"
          :defaultAvatarImage="defaultAvatarImage"
        ></component>
      </TabContainerItem>
    </TabContainer>
  </div>
</template>

<script>
import { TabContainer, TabContainerItem } from 'mint-ui';
import Launched from '../components/playHistory/Launched';
import Joined from '../components/playHistory/Joined';
import { mapActions, mapMutations, mapState } from 'vuex';
import { getUrlParam } from '@/utils';

const TabBarComponentBook = [
  {
    key: 'launched',
    contentComp: Launched,
    title: '我发起的'
  },
  {
    key: 'joined',
    contentComp: Joined,
    title: '我参与的'
  }
];

export default {
  components: {
    TabContainer,
    TabContainerItem,
    Launched,
    Joined
  },
  props: {
    actCode: String,
    moduleName: String
  },
  data() {
    return {
      tabBarConfig: TabBarComponentBook,
      dataReady: false
    };
  },
  computed: {
    ...mapState('app/inviteEarnCoupon/playHistory', [
      'currentActiveTabId',
      'defaultAvatarImage',
      'launchedRecords',
      'joinedRecords'
    ])
  },
  async created() {
    const defaultTab = getUrlParam('tab') || 'launched';
    this.setActiveTab(defaultTab);
    await this.getPlayHistory();
    this.dataReady = true;
    this.handleReportExpo(defaultTab);
  },
  methods: {
    ...mapMutations('app/inviteEarnCoupon/playHistory', ['setActiveTab']),
    ...mapActions('app/inviteEarnCoupon/playHistory', ['getPlayHistory']),
    handleTabBarClick(key) {
      this.setActiveTab(key);
      this.handleReportExpo(key);
    },
    handleReportExpo(tabKey) {
      let moduleName = '';
      if (tabKey === 'joined') {
        if (this.joinedRecords.length) {
          moduleName = '活动记录-我参与的';
        } else {
          moduleName = '活动记录-缺省页';
        }
      }
      if (tabKey === 'launched') {
        if (this.launchedRecords.length) {
          moduleName = '活动记录-我发起的';
        } else {
          moduleName = '活动记录-缺省页';
        }
      }
      this.$emit('reportEvent', {
        event: 'invite_boost_coupon_activity_expo',
        module_name: moduleName
      });
    },
    handleReportEvent(data) {
      this.$emit('reportEvent', data);
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100vh;
  background: #f3f4f5;
}
.tabBar {
  width: 100%;
  height: 80px;
  background: #fff;
  display: flex;
  justify-content: space-between;

  &:before,
  &:after {
    content: '';
    display: block;
  }

  .tabItem {
    box-sizing: border-box;
    height: 100%;
    display: flex;
    align-items: center;
    line-height: normal;
    font-size: 30px;
    color: #000;

    &.active {
      color: #ff0044;
      border-bottom: 4px solid #ff4354;
    }
  }
}

.tabContainer {
  width: 100%;
  height: calc(100vh - 80px);
  overflow-y: auto;
}
</style>
